import {
    Language as UrlIcon,
    TextFields as TextIcon,
    Phone as PhoneIcon,
    Email as EmailIcon,
    AccountTree as LinkTreeIcon,
    Description as FormIcon
} from "@mui/icons-material";
import { QrType } from "../types";


export const getIcon = (type: QrType) => {
    switch (type) {
        case QrType.URL:
            return <UrlIcon />;
        case QrType.TEXT:
            return <TextIcon />;
        case QrType.PHONE:
            return <PhoneIcon />;
        case QrType.EMAIL:
            return <EmailIcon />;
        case QrType.LINK_TREE:
            return <LinkTreeIcon />;
        case QrType.FORM:
            return <FormIcon />;
        default:
            return null;
    }
}